import DatePicker from "react-datepicker"
import { SelectPartner } from "@/features/partner"
import CalendarIcon from "@/shared/assets/images/CalendarBlank.svg"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { selectCurrentPartner, selectEndDate, selectStartDate, setEndDate, setSelectedPartner, setStartDate } from "../../model"

export const StoresFilters = () => {
    const selectedPartner = useAppSelector(selectCurrentPartner)
    const startDate = useAppSelector(selectStartDate)
    const endDate = useAppSelector(selectEndDate)
    const dispatch = useAppDispatch()
    
    const handleChangePartner = (value: string | null) => {
        dispatch(setSelectedPartner(value))
    }
    const handleDateRangeChange = (value: [Date, Date]) => {
        const [start, end] = value
        dispatch(setStartDate(start))
        dispatch(setEndDate(end))
    }

    return (
        <div className="grid grid-cols-10 gap-2">
            <div className="col-span-6">
                <SelectPartner value={selectedPartner} onChange={handleChangePartner} />
            </div>
            <div className="col-span-4">
                <DatePicker 
                    selected={startDate}
                    startDate={startDate}
                    onChange={handleDateRangeChange}
                    endDate={endDate}
                    selectsRange
                    wrapperClassName="react-datepicker-filterlike"
                    dateFormat={"dd.MM.yyyy"}
                    showIcon
                    enableTabLoop={false}
                    popperProps={{
                        placement: 'bottom'
                    }}
                    icon={(<CalendarIcon width={24} height={24}/>)}
                />
            </div>
        </div>
    )
}